// src/modules/app-views/account/pages/Init/modals/ChangePhoneModal/Step2.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useState } from 'react';
import { Typography } from 'antd';
import { MobileOutlined } from '@ant-design/icons';
import SimplePhone from 'components/SimpleComponents/SimplePhone';
import appService from 'services/appService';
import translateX from 'utils/translateX';

const { Text } = Typography;

// *******************************************************************************
// STEP CONTENT COMPONENT
// *******************************************************************************
const EnterNewPhoneStepContent = ({
  countryCode,
  setCountryCode,
  newPhoneDataRef,
}) => {
  const handleCountryChange = newCountryCode => {
    setCountryCode(newCountryCode);
    newPhoneDataRef.current.countryCode = newCountryCode;
  };

  const handlePhoneChange = e => {
    // SimplePhone returns the raw phone string via target.value
    const value = e?.target?.value || '';
    newPhoneDataRef.current.phone = value;
  };

  return (
    <>
      <Text type="secondary" style={{ display: 'block', marginBottom: 16 }}>
        {translateX('enter_new_phone_description')}
      </Text>

      <SimplePhone
        name={['newPhone', 'value']}
        label="new_phone"
        profile="mobile"
        required
        international
        countryCode={countryCode}
        onCountryChange={handleCountryChange}
        onChange={handlePhoneChange}
        prefix={<MobileOutlined className="text-primary" />}
      />
    </>
  );
};

// *******************************************************************************
// HELPERS
// *******************************************************************************
const validateNewPhone = async ({ form, goFocus, newPhoneDataRef }) => {
  // Get phone from ref (set via onChange) - this is the raw phone string
  const newPhone = newPhoneDataRef.current.phone;

  if (!newPhone || newPhone.trim() === '') {
    await appService.message({ flag: 'w', text: 'phone_is_required' });
    goFocus?.(['newPhone', 'value'], true);
    return false;
  }

  return true;
};

// *******************************************************************************
// STEP CONFIGURATION
// *******************************************************************************
const enterNewPhoneStep = ({ currentPhoneCountryCode, newPhoneDataRef }) => {
  let countryCode = currentPhoneCountryCode;

  return {
    stepTitle: 'new_phone',
    stepTooltip: 'enter_new_phone',
    content: ({ form, goFocus }) => {
      const [localCountryCode, setLocalCountryCode] = useState(countryCode);

      return (
        <EnterNewPhoneStepContent
          countryCode={localCountryCode}
          setCountryCode={newCode => {
            setLocalCountryCode(newCode);
            countryCode = newCode;
          }}
          newPhoneDataRef={newPhoneDataRef}
        />
      );
    },
    validationFields: ['newPhone.value'],
    onNext: async ({ form, goFocus }) =>
      validateNewPhone({ form, goFocus, newPhoneDataRef }),
    onEnter: ({ goFocus }) => {
      setTimeout(() => goFocus?.(['newPhone', 'value']), 100);
    },
  };
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default enterNewPhoneStep;
